import React from 'react';
import HeadingDescription from '../HeadingDescription';
import PointersWithoutHeading from '../PointersWithoutHeading';
// eslint-disable-next-line no-unused-vars -- used in JSX
import ProposalImage from '../ProposalImage';
import ovenImage from '../../assets/proposalImages/conveyorised_oven.png';

export default function OvenPowderCoatingPage({ ovenSection, ovenSpec, uploadedImage }) {
  if (!ovenSection) return null;

  const itemDetails = ovenSection.types?.[0]?.item_details;

  return (
    <div className="a4-paddings quotation-page quotation-machines-details-page">
      <div className="quotation-page-inner quotation-bg-light">
        {itemDetails && (
          <div className="quotation-section-block">
            <HeadingDescription
              heading="Powder Coating Curing Oven"
              description={[
                itemDetails.description,
                itemDetails.types_description,
                itemDetails.types_description_bottom,
              ]}
              level={3}
            />
            <PointersWithoutHeading items={(itemDetails.types || []).map((t) => t.text)} />
          </div>
        )}
        <ProposalImage src={uploadedImage || ovenImage} imgStyle={uploadedImage ? { maxHeight: 500, width: 'auto', objectFit: 'contain' } : {}} />
      </div>
    </div>
  );
}
